import React, { Component } from 'react';
import { get } from 'lodash';
import getConfig from 'next/config';

import css from './VerifyFunding.module.scss';
import layoutCSS from '../../components/Layout/Layout.module.scss';
import MaxAttemptsModal from './MaxAttemptsModal.tsx';
import AchModal from './AchModal.tsx';
import VerifyMicrodeposits from './VerifyMicrodeposits.tsx';

const { publicRuntimeConfig } = getConfig();

class VerifyFunding extends Component {
  state = {
    maxAttemptsModalOpen: false,
    displayHelpText: false
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.funding || this.props.needsVerification) {
      this.props.getFundingAccounts();
      this.props.queryGetUser();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorCode === 'ERR_MAX_CHALLENGE_WITHDRAWAL_VERIFICATIONS') {
      this.setState({ maxAttemptsModalOpen: true });
    }

    if (this.props.fundingAccounts !== nextProps.fundingAccounts) {
      if (
        nextProps.fundingAccounts &&
        nextProps.fundingAccounts.accountType === 'debit'
      ) {
        this.props.analytics.trackEvent('Verify Debit Viewed', {
          eventProps: {
            during_registration: true
          }
        });

        if (
          (get(publicRuntimeConfig, 'nodeEnv', 'dev') === 'dev' || 'staging') &&
          nextProps.registeredUser
        ) {
          this.props.getMicrodeposits(
            nextProps.registeredUser.jwt,
            nextProps.fundingAccounts.accountId,
            'debit'
          );
        }
      }
    }
  }

  verifyTrialWithdrawals = (amount1, amount2) => {
    if (amount1 && amount2) {
      this.props.analytics.trackEvent('Verify Debit Card Clicked', {
        eventProps: {
          during_registration: true
        }
      });

      this.props.verifyDebitNow({
        instantFundingAccountId: this.props.fundingAccounts.accountId,
        amount1,
        amount2
      });
    } else {
      this.props.createError({
        message: 'Please enter two amounts to verify the card.',
        registrationStep: 'verify_funding'
      });
    }
  };

  verifyLater = () => {
    this.props.analytics.trackEvent('Verify Debit Card Skipped', {
      eventProps: {
        during_registration: true
      }
    });
    this.props.clearError();
    this.props.verifyDebitLater();
  };

  render() {
    const showAchModal =
      !!(this.props.funding || this.props.needsVerification) &&
      this.props.fundingAccounts &&
      this.props.fundingAccounts.accountType === 'ach';
    const showVerifyMicrodeposits =
      !!this.props.fundingAccounts &&
      this.props.fundingAccounts.accountType !== 'ach';
    return (
      <div data-testid="verify-funding">
        {this.state.maxAttemptsModalOpen && (
          <MaxAttemptsModal onClickOk={this.props.verifyDebitLater} />
        )}

        {showAchModal && <AchModal onClickOk={this.props.verifyACHLater} />}

        <div className={css.VerifyFundingMainBox}>
          <div className={layoutCSS.layoutWrapper}>
            {showVerifyMicrodeposits && (
              <VerifyMicrodeposits
                error={this.props.error}
                message={this.props.message}
                loading={this.props.loading}
                fundingAccounts={this.props.fundingAccounts}
                onClickVerifyLater={this.verifyLater}
                onClickVerifyNow={(amount1, amount2) =>
                  this.verifyTrialWithdrawals(amount1, amount2)
                }
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default VerifyFunding;
